export * from "react-native-svg";
export { default } from "react-native-svg";
